import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from "../common/reducers/utilities";

const epcrComplaintSlice = createSlice({
    name: 'epcrComplaints',
    initialState: {
        defs: []
    },
    reducers: {
        setDefs: (state, action) => {
            state.defs = action.payload;
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => epcrComplaintSlice.getInitialState());
    }
});

// #region network operations
const fetchEpcrComplaintDefs = network => network.get('/api/v2/epcrComplaints', epcrComplaintSlice.actions.setDefs);
// #endregion

// #region selectors
const selectEpcrComplaintDefs = state => state.epcrComplaints.defs;
// #endregion

export const [useEpcrComplaints] = dataHookFactory(selectEpcrComplaintDefs, { run: fetchEpcrComplaintDefs });

const reducerDetails = { name: epcrComplaintSlice.name, reducer: epcrComplaintSlice.reducer };
export default reducerDetails;